///
/// EarthBrowser
///
/// Migration: v23 -> v24
/// Adds synoptic weather display settings
///
/// Created by Matt Giger on 1/18/2026
/// Copyright (c) 2026 Geodata Labs
///

interface StateV23 {
	earthbrowser?: {
		synopticSettings?: {
			isobarsVisible?: boolean
			pressureCentersVisible?: boolean
			jetStreamVisible?: boolean
		}
	}
}

export function migrateV23ToV24(state: unknown): unknown {
	const s = state as StateV23
	// Add synoptic settings with defaults to the earthbrowser slice
	if (s.earthbrowser && !s.earthbrowser.synopticSettings) {
		s.earthbrowser.synopticSettings = {
			isobarsVisible: true,
			pressureCentersVisible: true,
			jetStreamVisible: true,
		}
	}

	return state
}
